import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import Scrollbars from 'react-custom-scrollbars';
import Icon from '../../core/Icon';
import HeaderWidget from '../../containers/Header';
import Relieve from '../../../../assets/images/png/relieve.png';
import Button from '../../core/Buttons';

const StyledWidgetLayout = styled.div`
  ${props =>
    props.mini
      ? css`
          padding: 0;
        `
      : css`
          padding: ${rem('60px')} 0 0 0;
        `}
  background-color: rgba(0, 0, 0, 0.8);

  min-height: 100%;
  position: relative;

  &:before {
    /* ${props =>
      props.animate
        ? css`
            content: '';
          `
        : css`
            content: none;
          `}; */
    position: absolute;
    top: ${rem('60px')};
    left: 0;
    z-index: 100;
    width: 100%;
    height: ${rem('28px')};
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.23),
      rgba(255, 255, 255, 0)
    );
  }

  &:after {
    // content: '';
    position: absolute;
    top: ${rem('60px')};
    left: 0;
    z-index: 100;
    /* ${props =>
      props.animate
        ? css`
            width: 100%;
          `
        : css`
            width: 0;
          `}; */
    height: ${rem('2px')};
    background-color: ${props => props.theme.colors.dark};
    transition: width 0.3s ease-in-out;
  }

  /* &.minimized {
    display: flex;
    justify-content: space-between;
    align-items: center;
  } */

  .MinimizedWidget-maximize {
    display: block;
    width: ${rem('18px')};
    height: ${rem('18px')};
    fill: ${props => props.theme.colors.light};
    margin-right: ${rem('15px')};
  }

  .MinimizedWidget-icon {
    fill: ${props => props.theme.colors.light};
  }

  .btn-maximized {
    background-color: transparent;
    border: none;
    width: ${rem('14px')};
    height: ${rem('12px')};
    margin-right: ${rem('30px')};
  }
`;

const StyledMove = styled.div`
  float: left;
  width: ${rem('58px')};
  height: ${rem('14px')};
  background: url(${Relieve}) no-repeat 0 0;
  margin-left: ${rem('75px')};
  margin-top: ${rem('6px')};
  -webkit-app-region: drag;
`;

const StyledLinkMinimize = styled(Button)`
  float: right;
  height: ${rem('22px')};
  position: relative;
  z-index: 50;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: transparent;
  outline: none !important;
  box-shadow: none;
  .LayoutElectron-min {
    fill: ${props => props.theme.colors.light};
  }
`;

const StyledIconMinimize = styled(Icon)`
  width: ${rem('14px')};
  height: ${rem('8px')};
  outline: none !important;
  box-shadow: none;
`;

/** Widget minimizado */

export const StyledLink = styled(Link)`
  position: relative;
  margin-left: ${rem('15px')};

  &.notification:after {
    content: '';
    position: absolute;
    right: ${rem('-12px')};
    top: ${rem('-6px')};
    width: ${rem('10px')};
    height: ${rem('10px')};
    border-radius: 50%;
    background-color: #f74741;
  }
`;

export const StyledLogo = styled(Icon)`
  fill: ${props => props.theme.colors.light};
  width: ${rem('61px')};
  float: left;
`;

/** Cabecera */

const StyledHeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding: ${rem('20px')} ${rem('15px')};
`;

const StyledHeaderWidget = styled(HeaderWidget)`
  padding-top: 0;

  .Header-nav {
    background-color: transparent;
    border: none;
    padding-left: 0;
    margin-bottom: ${rem('45px')};
  }
  .Header-hamburger,
  .Header-listGeneral {
    display: none;
  }
`;

const StyledScrollbars = styled(Scrollbars)`
  height: 89% !important;
`;

/** Contenido */
const StyledContent = styled.div`
  padding: ${rem('10px')} ${rem('15px')} ${rem('120px')} ${rem('15px')};
`;

/** Navegación */
const StyledNavBar = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.9);
  width: 100%;
  height: ${rem('50px')};
  border-top: ${rem('2px')} solid ${props => props.theme.colors.primary};

  &:before {
    content: '';
    position: absolute;
    top: ${rem('-30px')};
    left: 0;
    width: 100%;
    height: ${rem('28px')};
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(0, 0, 0, 0.73) 73%
    );
    opacity: 0.17;
  }

  &:after {
    position: absolute;
    top: ${rem('-20px')};
    ${props =>
      props.arrowPosition &&
      css`
        content: '';
        left: ${props.arrowPosition}px;
      `}

    width: 0;
    height: 0;
    border-right: ${rem('6px')} solid transparent;
    border-top: ${rem('12px')} solid transparent;
    border-left: ${rem('6px')} solid transparent;
    border-bottom: ${rem('6px')} solid ${props => props.theme.colors.primary};
    transition: left 0.5s ease-in-out;
  }

  .NavBarWidget-list {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
  }
  .NavBarWidget-icon {
    width: ${rem('24px')};
    height: ${rem('25px')};
    fill: ${props => props.theme.colors.light};
  }
  .NavBarWidget-item {
    padding-left: 0;
    display: flex;
    align-items: center;
    position: relative;

    &:hover {
      .NavBarWidget-icon {
        fill: ${props => props.theme.colors.primary};
      }
    }

    &:before {
      display: none;
    }

    &.active {
      .NavBarWidget-icon {
        fill: ${props => props.theme.colors.primary};
      }
    }
    .NavBarWidget-noti.notification {
      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: ${rem('-6px')};
        width: ${rem('10px')};
        height: ${rem('10px')};
        border-radius: 50%;
        background-color: #f74741;
      }
    }
    .NavBarWidget-option {
      background-color: ${props => props.theme.colors.dark};
      color: ${props => props.theme.colors.light};
      margin: 0;
      padding: ${rem('12px')} 0;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 0.5s;
      &:before {
        content: none;
      }
      &:hover {
        color: ${props => props.theme.colors.primary};
        .NavBarWidget-logout {
          fill: ${props => props.theme.colors.primary};
        }
      }
    }
    .NavBarWidget-logout {
      fill: ${props => props.theme.colors.light};
      width: ${rem('18px')};
      margin-right: ${rem('6px')};
      margin-top: -4px;
    }
    .NavBarWidget-btn-options {
      background: none;
      border: none;
    }
  }
`;

const StyledOptions = styled.ul`
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: ${rem('50px')};
  left: 0;
  width: 100%;
  ${props =>
    props.active
      ? css`
          display: block;
        `
      : css`
          display: none;
        `}
`;

export {
  StyledWidgetLayout,
  StyledHeaderWrapper,
  StyledHeaderWidget,
  StyledScrollbars,
  StyledContent,
  StyledLinkMinimize,
  StyledIconMinimize,
  StyledMove,
  StyledNavBar,
  StyledOptions
};
